import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICategory, ICatalog, initialState } from './types'

export const CategoriesSlice = createSlice({
  name: 'categoriesSlice',
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<ICategory[]>) {
      state.items = action.payload
    },
    setSoldOutIds(state, action: PayloadAction<number[]>) {
      state.soldOutIds = action.payload || []
    },
    setIsLoaded(state) {
      state.isLoaded = true
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
  },
})

export default CategoriesSlice.reducer
export type { ICatalog }
